const perOfferDynamicBadgeStyles = ({ uuid, badgeStyle }) => `
.saso-offer-badge-style-${uuid} {
  --color: ${badgeStyle.color};
  --background: ${badgeStyle.background};
}
`;

export default perOfferDynamicBadgeStyles;
